// extracted by mini-css-extract-plugin
module.exports = {"root":"slider-tabs_root__tDQC0","fullWidth":"slider-tabs_fullWidth___1GdN","tabButton":"slider-tabs_tabButton__Mfbni","activeButton":"slider-tabs_activeButton__2jfFv"};